import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { cn } from "../../lib/utils";

const DEFAULT_INDICATOR_BACKGROUND =
	"linear-gradient(180deg, #5EAE91 0%, #186146 100%)";

type ProgressProps = React.ComponentPropsWithoutRef<
	typeof ProgressPrimitive.Root
> & {
	indicatorClassName?: string;
	indicatorBackground?: string;
	indicatorStroke?: string;
	indicatorStrokeWidth?: number;
};

const Progress = React.forwardRef<
	React.ElementRef<typeof ProgressPrimitive.Root>,
	ProgressProps
>(
	(
		{
			className,
			value,
			indicatorClassName,
			indicatorBackground = DEFAULT_INDICATOR_BACKGROUND,
			indicatorStroke,
			indicatorStrokeWidth = 1,
			...props
		},
		ref,
	) => (
		<ProgressPrimitive.Root
			ref={ref}
			className={cn(
				"relative h-4 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800",
				className,
			)}
			{...props}
		>
			<ProgressPrimitive.Indicator
				className={cn(
					"relative h-full w-full flex-1 transition-all dark:bg-slate-50",
					indicatorClassName,
				)}
				style={{
					background: indicatorBackground,
					width: `${value || 0}%`,
				}}
			>
				{indicatorStroke ? (
					<span
						aria-hidden
						className="pointer-events-none absolute inset-0 rounded-[inherit]"
						style={{
							padding: indicatorStrokeWidth,
							background: indicatorStroke,
							WebkitMask:
								"linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
							WebkitMaskComposite: "xor",
							maskComposite: "exclude",
						}}
					/>
				) : null}
			</ProgressPrimitive.Indicator>
		</ProgressPrimitive.Root>
	),
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
export type { ProgressProps };
